/**
 * Step 10 — Ministry Map seed
 *
 * Spec: specs/onboarding-rebuild.md → Act 2 step 10
 *
 * The SOLE skippable step in onboarding. Captures one person to seed the
 * user's Ministry Map so they exit onboarding with someone they're already
 * praying for. Production wrapper passes onAdd → createPerson() and
 * onSkip → next step. Admin preview stubs both.
 */

import MinistryMapSeedSynthesis from './MinistryMapSeed.synthesis'

export default function MinistryMapSeedStep({ onAdd, onSkip }) {
  return <MinistryMapSeedSynthesis onAdd={onAdd} onSkip={onSkip} />
}
